<template>
  <div class="w-full overflow-y-hidden scroll-smooth bg-white">
    <HomeNavbar />
    <main>
      <slot />
    </main>
    <FooterSection />
  </div>
</template>

<style>
::-moz-selection {
  color: #fff;
  background: #037957;
}

::selection {
  color: #fff;
  background: #037957;
}
</style>
